import React, { useState } from "react";
import { AnimatePresence, motion, PanInfo } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, ZoomInIcon } from "lucide-react";
import { samplePages } from "../data/content";
import { SectionTitle } from "./SectionTitle";
export function SampleCarousel() {
  const [index, setIndex] = useState(0);
  if (samplePages.length === 0) return null;
  const total = samplePages.length;
  const page = samplePages[index];
  const go = (dir: number) => setIndex(i => (i + dir + total) % total);
  const onDragEnd = (_: unknown, info: PanInfo) => {
    if (info.offset.x < -50) go(1);else if (info.offset.x > 50) go(-1);
  };
  return <section className="bg-forest px-4 py-16 sm:px-6 sm:py-24" data-id="element-153" data-mp="2k681yow7e19l">
      <SectionTitle title={<>Regardez un peu <span className="text-gold" data-id="element-155" data-mp="18oyn6fo0rxem">le contenu à l'intérieur</span></>} subtitle="Quelques pages réelles du pack d'exercices techniques. Chaque exercice indique le tempo, le doigté et comment le faire répéter." data-id="element-154" data-mp="2g28pqihyhom1" />
      <div className="mx-auto mt-10 max-w-4xl" data-id="element-156" data-mp="1j1llt91kevo9">
        <div className="relative overflow-hidden rounded-2xl border border-moss bg-white shadow-[0_20px_50px_rgba(0,0,0,0.45)]" data-id="element-157" data-mp="1izsjg5xzixm2">
          <AnimatePresence mode="wait" initial={false} data-id="element-158" data-mp="1a1gppv1tnjpe">
            <motion.img key={page.image} src={page.image} alt={`Page d'exemple : ${page.title}`} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.2} onDragEnd={onDragEnd} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="aspect-[16/9] w-full cursor-grab touch-pan-y select-none object-contain active:cursor-grabbing" draggable={false} data-id="element-159" data-mp="1a0xc2qj7fhh6" />
          </AnimatePresence>
          <a href={page.image} target="_blank" rel="noreferrer" className="absolute bottom-3 right-3 flex items-center gap-1.5 rounded-full bg-ink/85 px-3 py-1.5 text-xs font-semibold text-white transition-colors duration-150 hover:bg-ink" data-id="element-160" data-mp="maksgieljwar">
            <ZoomInIcon className="h-3.5 w-3.5" aria-hidden data-id="element-161" data-mp="2ec0c7krqzsp7" />
            Agrandir
          </a>
        </div>

        <div className="mt-5 flex items-center justify-between gap-4" data-id="element-162" data-mp="2aaoip45r6nbq">
          <button onClick={() => go(-1)} aria-label="Page précédente" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-golddark text-gold transition-colors duration-150 hover:bg-moss" data-id="element-163" data-mp="3705w65az9dnz">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-164" data-mp="2szv8fb4ysf71" />
          </button>
          <div className="flex items-center gap-2" role="tablist" aria-label="Choisir une page" data-id="element-165" data-mp="2szlg3gwg5vy6">
            {samplePages.map((p, i) => <button key={p.image} role="tab" aria-selected={i === index} aria-label={p.title} onClick={() => setIndex(i)} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? "w-8 bg-gold" : "w-2.5 bg-white/30 hover:bg-white/50"}`} data-id="element-166" data-mp="1hkzg4mdeaf80" data-mpi={i} />)}
          </div>
          <button onClick={() => go(1)} aria-label="Page suivante" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-golddark text-gold transition-colors duration-150 hover:bg-moss" data-id="element-167" data-mp="av3sceenedk4">
            <ChevronRightIcon className="h-5 w-5" data-id="element-168" data-mp="prm6o8i1pdng" />
          </button>
        </div>

        <p className="mt-4 text-center font-display text-lg font-bold text-gold" aria-live="polite" data-id="element-169" data-mp="tsxymkoe6ayt">
          {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
        </p>
        <h3 className="mt-1 text-center font-display text-2xl font-bold uppercase text-white sm:text-3xl" data-id="element-170" data-mp="2rl29s4vbkkzb">{page.title}</h3>
        <p className="mx-auto mt-2 max-w-xl text-center text-white/75" data-id="element-171" data-mp="209lai7xeqynx">{page.caption}</p>
      </div>
    </section>;
}